
const cartCheckoutMixin = {

    data: {
        checkoutChecked: false
    },

    computed: {
        isCheckoutAvailable() {
            return this.checkoutChecked && this.cartItems.length > 0
        },
    },

    watch: {
        isCheckoutAvailable: function (newProductOptions, oldProductOptions) {
            //console.log(newProductOptions)
        },
    },
}

export default cartCheckoutMixin;
